/* TailorTail Co — Global JavaScript */

(function() {
  'use strict';

  // Mobile menu toggle
  var menuToggle = document.querySelector('[data-menu-toggle]');
  var mobileNav = document.querySelector('[data-mobile-nav]');

  if (menuToggle && mobileNav) {
    menuToggle.addEventListener('click', function() {
      var isExpanded = this.getAttribute('aria-expanded') === 'true';
      this.setAttribute('aria-expanded', !isExpanded);
      mobileNav.hidden = isExpanded;
    });
  }

  // Desktop dropdown keyboard support
  var dropdownItems = document.querySelectorAll('.header__nav-item--has-dropdown');
  dropdownItems.forEach(function(item) {
    var link = item.querySelector('.header__nav-link');
    var dropdown = item.querySelector('.header__dropdown');
    if (!link || !dropdown) return;

    link.setAttribute('aria-haspopup', 'true');
    link.setAttribute('aria-expanded', 'false');

    function openDropdown() {
      link.setAttribute('aria-expanded', 'true');
      item.classList.add('is-dropdown-open');
    }

    function closeDropdown() {
      link.setAttribute('aria-expanded', 'false');
      item.classList.remove('is-dropdown-open');
    }

    item.addEventListener('mouseenter', openDropdown);
    item.addEventListener('mouseleave', closeDropdown);

    link.addEventListener('keydown', function(e) {
      if (e.key === 'Enter' || e.key === ' ' || e.key === 'ArrowDown') {
        e.preventDefault();
        openDropdown();
        var firstLink = dropdown.querySelector('.header__dropdown-link');
        if (firstLink) firstLink.focus();
      }
    });

    link.addEventListener('focus', function() {
      openDropdown();
    });

    dropdown.addEventListener('keydown', function(e) {
      var links = Array.from(dropdown.querySelectorAll('.header__dropdown-link'));
      var currentIndex = links.indexOf(document.activeElement);

      if (e.key === 'ArrowDown') {
        e.preventDefault();
        var next = links[currentIndex + 1] || links[0];
        next.focus();
      } else if (e.key === 'ArrowUp') {
        e.preventDefault();
        var prev = links[currentIndex - 1] || links[links.length - 1];
        prev.focus();
      } else if (e.key === 'Escape') {
        e.preventDefault();
        closeDropdown();
        link.focus();
      } else if (e.key === 'Tab' && !e.shiftKey && currentIndex === links.length - 1) {
        closeDropdown();
      } else if (e.key === 'Tab' && e.shiftKey && currentIndex === 0) {
        closeDropdown();
      }
    });

    item.addEventListener('focusout', function(e) {
      if (!item.contains(e.relatedTarget)) {
        closeDropdown();
      }
    });
  });

  // Update cart count globally
  window.TailorTail = window.TailorTail || {};

  window.TailorTail.updateCartCount = function(count) {
    var badges = document.querySelectorAll('[data-cart-count]');
    badges.forEach(function(badge) {
      badge.textContent = count;
      badge.setAttribute('data-cart-count', count);
    });
  };

  // Fetch cart state
  window.TailorTail.getCart = function() {
    return fetch('/cart.js', {
      headers: { 'Content-Type': 'application/json' }
    }).then(function(res) { return res.json(); });
  };

  // Announcement bar dismiss
  var announcementClose = document.querySelector('[data-announcement-close]');
  var announcementBar = document.querySelector('[data-announcement-bar]');
  if (announcementClose && announcementBar) {
    if (sessionStorage.getItem('announcement_dismissed')) {
      announcementBar.hidden = true;
    }
    announcementClose.addEventListener('click', function() {
      announcementBar.hidden = true;
      sessionStorage.setItem('announcement_dismissed', '1');
    });
  }

  // Header scroll effect
  var header = document.querySelector('[data-header]');
  if (header) {
    var onScroll = function() {
      header.classList.toggle('header--scrolled', window.scrollY > 20);
    };
    window.addEventListener('scroll', onScroll, { passive: true });
    onScroll();
  }

  // Mobile submenu toggle
  document.querySelectorAll('.header__mobile-toggle').forEach(function(btn) {
    btn.addEventListener('click', function() {
      var expanded = btn.getAttribute('aria-expanded') === 'true';
      btn.setAttribute('aria-expanded', String(!expanded));
      var sublist = btn.nextElementSibling;
      if (sublist) sublist.hidden = expanded;
    });
  });

  // Scroll-reveal system
  var revealElements = document.querySelectorAll('[data-reveal]');
  if (revealElements.length > 0 && !window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
    var revealObserver = new IntersectionObserver(function(entries) {
      entries.forEach(function(entry) {
        if (entry.isIntersecting) {
          var el = entry.target;
          var delay = parseInt(el.getAttribute('data-reveal-delay') || '0', 10);
          setTimeout(function() {
            el.classList.add('is-visible');
          }, delay);
          revealObserver.unobserve(el);
        }
      });
    }, { threshold: 0.1, rootMargin: '0px 0px -40px 0px' });

    revealElements.forEach(function(el) {
      revealObserver.observe(el);
    });
  }

  // Stagger children reveal
  var staggerContainers = document.querySelectorAll('[data-stagger]');
  if (staggerContainers.length > 0 && !window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
    var staggerObserver = new IntersectionObserver(function(entries) {
      entries.forEach(function(entry) {
        if (entry.isIntersecting) {
          var container = entry.target;
          var children = container.querySelectorAll('[data-stagger-item]');
          var baseDelay = parseInt(container.getAttribute('data-stagger') || '100', 10);
          children.forEach(function(child, index) {
            setTimeout(function() {
              child.classList.add('is-visible');
            }, index * baseDelay);
          });
          staggerObserver.unobserve(container);
        }
      });
    }, { threshold: 0.1, rootMargin: '0px 0px -40px 0px' });

    staggerContainers.forEach(function(el) {
      staggerObserver.observe(el);
    });
  }

  // Mobile size chart unit toggle
  var mobileSizeChart = document.querySelector('#mobile-size-chart');
  if (mobileSizeChart) {
    mobileSizeChart.addEventListener('click', function(e) {
      var tab = e.target.closest('[data-mobile-unit-tab]');
      if (!tab) return;
      var unit = tab.getAttribute('data-mobile-unit-tab');
      mobileSizeChart.querySelectorAll('[data-mobile-unit-tab]').forEach(function(t) {
        t.classList.remove('is-active');
        t.setAttribute('aria-selected', 'false');
      });
      tab.classList.add('is-active');
      tab.setAttribute('aria-selected', 'true');
      mobileSizeChart.querySelectorAll('[data-mobile-unit-panel]').forEach(function(p) {
        p.hidden = p.getAttribute('data-mobile-unit-panel') !== unit;
      });
    });
  }
})();
